module.exports = __webpack_public_path__ + "img/redr.cd7771f.png";